import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
  import { CommonModule } from '@angular/common';
  import { Router, RouterModule } from '@angular/router';
  import { TranslateModule } from '@ngx-translate/core';
  import { AlertType, IActivityLog, RemovedActivationRoute } from 'app/models/activity-log.model';
  import { Device } from 'app/models/device.model';
  import { HelperService } from 'app/services/helper.service';
  import {
    IdentityFormatPipe,
    MomentPipe
  } from 'app/pipes/pipes';
  
  import {
    AnchorWrapPipe,
    StrongWrapPipe
  } from '../activity-log-table/activity-log-table-pipes';
  
  @Component({
    selector: 'app-activity-device-details',
    imports: [
        CommonModule,
        TranslateModule,
        RouterModule,
        MomentPipe,
        IdentityFormatPipe,
    ],
    templateUrl: './activity-device-details.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    styleUrls: ['../activity-details-dialog/activity-details-content-styles.css']
})
  export class ActivityDeviceDetailsComponent implements OnChanges {
  
    constructor(
      private router: Router,
      private helper: HelperService
    ) {}
  
    @Input() log: IActivityLog;
    @Output() closeDialog = new EventEmitter<void>();
  
    device: Device | null = null;
  
    ngOnChanges(): void {}

    getDeviceTypeName(type: string): string {
        const devTypes = JSON.parse(localStorage.getItem('devType') || '[]');
        const found = devTypes.find(d => d.deviceType === type);
        return found ? `${found.deviceTypeName} (${found.deviceTypeCode})` : type;
    }

    getActivationTypeName(group: number, node: number, deviceType: string): string {
      if (group == null || node == null || !deviceType) {
        return '';
      }

      return this.helper.getActivationName(group, node, deviceType, '', 0);
    }

    getRemovedActivationEntries(): { routeLabel?: string; activation: string }[] {
      const removedActivations = this.log?.details?.deviceChanges?.removedActivations as
        | AlertType[]
        | RemovedActivationRoute[]
        | undefined;

      if (!Array.isArray(removedActivations) || removedActivations.length === 0) {
        return [];
      }

      const first = removedActivations[0] as AlertType | RemovedActivationRoute;
      if ('alertTypes' in first || 'routeId' in first || 'routeName' in first) {
        return (removedActivations as RemovedActivationRoute[]).flatMap(route => {
          const routeLabel = `${route?.routeName || ''} (${route?.routeId || ''})`;
          const alertTypes = Array.isArray(route?.alertTypes) ? route.alertTypes : [];

          return alertTypes.map(alertType => ({
            routeLabel,
            activation: this.getActivationTypeName(
              alertType?.group,
              alertType?.node,
              alertType?.devType || this.log?.details?.deviceChanges?.deviceType
            )
          }));
        });
      }

      return (removedActivations as AlertType[]).map(alertType => ({
        activation: this.getActivationTypeName(
          alertType?.group,
          alertType?.node,
          alertType?.devType || this.log?.details?.deviceChanges?.deviceType
        )
      }));
    }
  
    @HostListener('document:click', ['$event'])
    handleClick(event: Event): void {
      const element = event.target as HTMLElement;
  
      if (element.tagName.toLowerCase() === 'a') {
        const classList = element.classList;
  
        if (classList.contains('staff')) {
          event.preventDefault();
  
          const dataUrl = element.getAttribute('data-url');
          if (dataUrl) {
            this.router.navigateByUrl(dataUrl);
          }
  
          this.closeDialog.emit();
        }
      }
    }
  }